import React, { useState, useEffect } from "react";

// components
import Fitem from "./FitemWrapper";

// css
import "./Literature.css";

function Literature() {
  const prodKey = process.env.REACT_APP_PRODUCT_KEY;

  // states
  const [fetchedData, setFetchedData] = useState([]);
  const [tabName, setTabName] = useState("");
  const [fItems, setFItems] = useState([]);

  // console.log(tabName);

  async function fetchData() {
    const litFilePath = sessionStorage.getItem("litFileName");
    const prUrl = process.env.REACT_APP_PUBLICRATES_URL;
    const url = `${prUrl}${litFilePath}.json`;
    const response = await fetch(url);
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
    const data = await response.json();
    // console.log(data);
    // console.log(data.product.section);
    if (data?.product?.section) {
      // Handle if data.product.section is an array or a single object
      const section = Array.isArray(data.product.section)
        ? data.product.section
        : [data.product.section]; // Convert single item to an array for consistent handling

      // Set fetched data to the normalized array
      setFetchedData(section);

      // Set the first item of the array to the tab name, if it exists
      if (section.length > 0) {
        setTabName(section[0]["@name"]);
      }
    }
    // setFetchedData(data.product.section);
    // setTabName(data.product.section[0]["@name"]);
    Array.isArray(data.product.section[0].fitem)
      ? data.product.section[0].fitem.map((fItem) => {
          // console.log(fItem);
          fItems.push(fItem);
        })
      : setFItems(data.product.section[0].fitem);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const displayTabs = () => {
    if (Array.isArray(fetchedData)) {
      const tabArray = fetchedData.map((tabs) => {
        // console.log(tabs);
        return (
          <button
            className={
              tabName === tabs["@name"] ? "border-bottom tablinks" : "tablinks"
            }
            onClick={() => {
              setTabName(tabs["@name"]);
              getItems(tabs["@name"]);
            }}
          >
            {tabs["@name"]}
          </button>
        );
      });
      return tabArray;
    } else {
      return (
        <button
          className={
            tabName === fetchedData["@name"]
              ? "border-bottom tablinks"
              : "tablinks"
          }
          onClick={setTabName(fetchedData["@name"])}
        >
          button
        </button>
      );
    }
  };

  const getItems = (tName) => {
    fetchedData
      .filter((name) => name["@name"] === tName)
      .map((fItem) => {
        // console.log(fItem.fitem);
        setFItems(fItem.fitem);
      });
  };

  return (
    <section id="literature">
      <div className="main-padding">
        <div className="main-margin">
          <div className="tab bg-hmcGray-dark">{displayTabs()}</div>
          <div className="tab-content-grid">
            {Array.isArray(fItems) ? (
              fItems.map((item) => {
                return (
                  <Fitem
                    DlUrl={item.download_url}
                    imgURL={item.thumbnail_image}
                    name={item.item_name}
                    isHosted={item.hosted_video}
                    hostedPath={item.hosted_video_document_path}
                    sku={item.item_sku}
                  />
                );
              })
            ) : (
              <Fitem
                DlUrl={fItems.download_url}
                imgURL={fItems.thumbnail_image}
                name={fItems.item_name}
                isHosted={fItems.hosted_video}
                hostedPath={fItems.hosted_video_document_path}
                sku={fItems.item_sku}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Literature;
